import React from 'react';
import { useDocumentTitle } from '../../shared/use-document-title';
import { PageHeader } from '../../components/PageHeader';
import aboutUsDesktopImageSrc from '../../assets/images/page/about-us-desktop.png';
import aboutUsMobileImageSrc from '../../assets/images/page/about-us-mobile.png';
import styles from './AboutUsPage.css';
import { Icon } from '../../components/Icon';

const STRENGTHS_LIST = [
    {
        id: 1,
        heading: 'Comprehensive focus',
        description: 'covering all aspects of life’s challenges, from health and finance to digital and legal safety'
    },
    {
        id: 2,
        heading: 'AI-driven Insights',
        description: 'advanced technology that offers tailored, actionable recommendations to enhance your preparedness'
    },
    {
        id: 3,
        heading: 'Affordability',
        description: 'more cost-effective and practical than traditional insurance solutions'
    },
    {
        id: 4,
        heading: 'Future-ready support',
        description: 'assessing your current confidence and readiness to help you thrive in an uncertain world'
    },
    {
        id: 5,
        heading: 'User-centric design',
        description: 'tools designed to make security and peace of mind accessible to everyone'
    }
];

function AboutUsPage() {
    useDocumentTitle('About us');

    return (
        <>
           <PageHeader
                title='Our mission'
                description='To empower individuals to take control of their safety and well-being across five essential areas: physical safety, financial stability, digital protection, food safety, and legal rights. We aim to provide accessible, AI-driven tools and personalized guidance that go beyond traditional insurance, helping you build a more secure and confident future.'
                desktopImageUrl={aboutUsDesktopImageSrc}
                mobileImageUrl={aboutUsMobileImageSrc}
            />
            <div className={styles.box}>
                <h2 className={styles.title}>Our strengths</h2>
                <ul>
                    {STRENGTHS_LIST.map(item => (
                        <li key={item.id}>
                            <Icon name='checkedItem' />
                            <span><strong>{item.heading}:</strong> {item.description}.</span>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    )
};

export {
    AboutUsPage
};
